document.addEventListener('click', event => {
  const toggle = event.target.closest('[data-billing-ddt-toggle]');
  if (!toggle) return;
  const expanded = toggle.getAttribute('aria-expanded') !== 'true';
  document.querySelectorAll(`[data-billing-ddt-detail="${toggle.dataset.billingDdtToggle}"]`).forEach(row => {
    row.hidden = !expanded;
  });
  toggle.setAttribute('aria-expanded', String(expanded));
  toggle.setAttribute('aria-label', expanded ? 'Nascondi dettaglio DDT' : 'Mostra dettaglio DDT');
  toggle.textContent = expanded ? '−' : '+';
});

document.addEventListener('turbolinks:load', () => {
  const editTotal = document.querySelector('.billing-edit-total[readonly]');
  if (editTotal) {
    const editForm = editTotal.closest('form');
    editForm.querySelectorAll('.billing-edit-quantity, .billing-edit-price').forEach(input => {
      input.addEventListener('input', () => {
        const quantity = Number(editForm.querySelector('.billing-edit-quantity').value) || 0;
        const price = Number(editForm.querySelector('.billing-edit-price').value) || 0;
        editTotal.value = (quantity * price * Number(editTotal.dataset.factor)).toFixed(2);
      });
    });
  }
  const form = document.querySelector('form input[name="source"][value="from_table_form"]')?.closest('form');
  if (!form || form.dataset.billingInitialized) return;
  form.dataset.billingInitialized = 'true';
  document.addEventListener('turbolinks:before-cache', () => {
    delete form.dataset.billingInitialized;
  }, { once: true });

  const parseEuro = value => {
    const clean = String(value || '').replace(/[^\d,.-]/g, '');
    return Number(clean.replace(/\./g, '').replace(',', '.')) || 0;
  };
  const formatEuro = value => new Intl.NumberFormat('it-IT', {
    style: 'currency', currency: 'EUR'
  }).format(value);

  function calculate(row) {
    const quantity = row.querySelector('.quantity');
    const priceDisplay = row.querySelector('.unit_price_display');
    const numericPrice = row.querySelector('.unit_price_numeric');
    const total = row.querySelector('.total_price_numeric');
    if (!quantity || !total || total.disabled || (!priceDisplay && !numericPrice)) return;
    const price = numericPrice ? Number(numericPrice.value) || 0 : parseEuro(priceDisplay.value);
    const priceHidden = row.querySelector('.unit_price_hidden');
    if (priceHidden) priceHidden.value = price.toFixed(2);
    const factor = 1 - (Number(row.dataset.depositPercentage) || 0) / 100;
    total.value = ((Number(quantity.value) || 0) * price * factor).toFixed(2);
  }

  function updateDdtAmounts(input) {
    const hasTotal = Array.from(form.querySelectorAll(`.ddt-document-total[data-ddt-id="${input.dataset.ddtId}"]`))
      .some(total => Number(total.value) > 0);
    form.querySelectorAll(`tr[data-ddt-line-id="${input.dataset.ddtId}"]`).forEach(row => {
      row.querySelectorAll('.unit_price_numeric, .total_price_numeric, .duplicate-row').forEach(field => {
        field.disabled = hasTotal;
      });
      const type = row.querySelector('select[name$="[billing_slip_type]"]');
      if (type) {
        if (hasTotal && !type.disabled) {
          type.dataset.previousValue = type.value;
          type.selectedIndex = -1;
        } else if (!hasTotal && type.disabled) {
          type.value = type.dataset.previousValue || 'carpenteria';
        }
        type.disabled = hasTotal;
      }
    });
  }
  form.querySelectorAll('.ddt-document-total').forEach(updateDdtAmounts);

  function updateSummaryRowspan(section) {
    const cell = section.querySelector('.ddt-summary-toggle-cell');
    if (cell) cell.rowSpan = section.querySelectorAll('.ddt-introduction-row').length;
  }

  form.addEventListener('input', event => {
    if (event.target.matches('.ddt-document-total')) updateDdtAmounts(event.target);
    if (event.target.matches('.quantity, .unit_price_display, .unit_price_numeric')) {
      calculate(event.target.closest('tr'));
    }
    // Il totale è una proposta calcolata; il server lo ricalcola al salvataggio.
  });
  form.addEventListener('focusout', event => {
    if (event.target.matches('.unit_price_display')) {
      event.target.value = formatEuro(parseEuro(event.target.value));
    }
  });

  form.addEventListener('click', event => {
    const remove = event.target.closest('.remove-billing-copy');
    if (remove) {
      const section = remove.closest('tbody');
      const documentTotal = remove.closest('tr').querySelector('.ddt-document-total');
      remove.closest('tr').remove();
      if (documentTotal) updateDdtAmounts(documentTotal);
      if (section) updateSummaryRowspan(section);
      return;
    }
    const button = event.target.closest('.duplicate-row');
    if (!button) return;
    const original = button.closest('tr');
    const copy = original.cloneNode(true);
    const key = `copy_${Date.now()}_${Math.random().toString(36).slice(2)}`;
    copy.classList.add('cloned-row');
    copy.querySelector('.ddt-summary-toggle-cell')?.remove();
    copy.querySelectorAll('input, select, textarea, label').forEach(element => {
      if (element.dataset.index !== undefined) element.dataset.index = key;
      if (element.name) element.name = element.name.replace(/billing_slips\[[^\]]+\]/, `billing_slips[${key}]`);
      if (element.id) element.id = `${element.id}_${key}`;
      if (element.htmlFor) element.htmlFor = `${element.htmlFor}_${key}`;
    });
    original.querySelectorAll('select').forEach((select, index) => {
      copy.querySelectorAll('select')[index].value = select.value;
    });
    copy.querySelector('.generated_copy_flag').value = 'true';
    const removeButton = document.createElement('button');
    removeButton.type = 'button';
    removeButton.className = 'btn btn-sm btn-outline-danger remove-billing-copy';
    removeButton.title = 'Elimina copia';
    removeButton.setAttribute('aria-label', 'Elimina copia');
    const trashIcon = document.createElement('i');
    trashIcon.className = 'fa fa-trash';
    trashIcon.setAttribute('aria-hidden', 'true');
    removeButton.appendChild(trashIcon);
    copy.querySelector('.duplicate-row').replaceWith(removeButton);
    // Le copie condividono l'ordine: niente componenti o cambio stato duplicati.
    copy.querySelectorAll('.order-components-link').forEach(link => link.remove());
    copy.querySelector('.order-invoiced-action')?.replaceChildren();
    original.after(copy);
    updateSummaryRowspan(original.closest('tbody'));
    const documentTotal = copy.querySelector('.ddt-document-total');
    if (documentTotal) updateDdtAmounts(documentTotal);
  });
});
